export default __webpack_public_path__ + "static/2019_14-9a8052c68c7adbdc790b8a3606a525e0.png";